import {download, get, post} from "@/utils/http"

export const _selectPages = params => get("/connersQrCode/selectPages", params);
export const _get = params => get("/connersQrCode/get", params);
export const _genQrCode = params => post("/connersQrCode/genQrCode", params);
export const _updateStatus = params => get("/connersQrCode/updateStatus", params);
export const _delete = params => get("/connersQrCode/delete", params);
export const _download = params => download("/connersQrCode/download", params);



